<template>
  <div id="devicetype-page">
    <DeviceInstructionPage 
      :back="back"
      @install="install" />
  </div>
</template>

<script>
import Button from "../components/UI/Button";
import MobileType from "../components/DeviceType/MobileType";
import DeviceInstructionPage from "../components/DeviceType/DeviceInstructionPage";
import store from "../config/store";

export default {
  name: "DeviceType",
  props: {
    back: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Button,
    MobileType,
    DeviceInstructionPage,
    store
  },

  created() {
    this.init()
  },

  mounted() {
    const isInstalled = window.matchMedia("(display-mode: standalone)").matches
    isInstalled ? this.$router.push('/dashboard') : this.findIos() 
  },

  methods: {
    findIos() {
      const isIos = () => {
        const userAgent = window.navigator.userAgent.toLowerCase();
        return /iphone|ipad|ipod/.test(userAgent);
      };
      this.$setState('devicetype', isIos() ? 'iphone-instruction' : 'android-instruction')
    },
    init() {
      window.addEventListener("beforeinstallprompt", e => {
        e.preventDefault();
        this.deferredPrompt = e;
      });

      window.addEventListener("appinstalled", evt => {
        this.$router.push('/dashboard')
      });
    },
    install() {
      if (this.deferredPrompt) {
        this.deferredPrompt.prompt();
        this.deferredPrompt.userChoice.then(function(choiceResult) {
            if (choiceResult.outcome === "accepted") {
              console.log("User accepted the A2HS prompt");
            } else {
              console.log("User dismissed the A2HS prompt");
            }
            this.$router.push('/dashboard')
            this.deferredPrompt = null;
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
#devicetype-page {
  height: 100vh;
  display: flex;
  #device-instruction-page {
    margin: auto 0;
  }
}
</style>
